var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ fontSize: _vm.fontSize, color: '#fff' })},[_c('h2',[_vm._v("自定义组件")]),_c('h3',[_vm._v("我是参数:"+_vm._s(_vm.option.data))])])}
var staticRenderFns = []

export { render, staticRenderFns }